import { Form } from "react-bootstrap";
import "react-phone-input-2/lib/style.css";
import { useContext, useEffect } from "react";
import { TicketContext } from "../../store/ticket-context";
import { useState } from "react";

const EmailForm = (props) => {
  const [eneteredEmail, setEnteredEmail] = useState("");
  const ticket = useContext(TicketContext);

  useEffect(() => {
    // console.error(ticket);
    if (ticket !== null) {
      setEnteredEmail(ticket.email);
      props.sendEmail(ticket.email);
    }
  }, [ticket]);

  const handleOnChange = (event) => {
    setEnteredEmail(event.target.value);
    console.log(eneteredEmail);
    props.sendEmail(ticket.email);
  };

  const sendEmail = () => {
    props.sendEmail(eneteredEmail);
  };

  return (
    <div>
      <div className="invite-help-text">
        Enter guest's email and click the below button to send an Invitation.
      </div>
      <Form.Group className="mx-3 mb-3" controlId="formWhatsapp">
        <Form.Control
          noValidate
          autoFocus
          type="text"
          onChange={handleOnChange}
          onBlur={sendEmail}
          value={eneteredEmail}
          placeholder="Enter email"
        />
      </Form.Group>
    </div>
  );
};

export default EmailForm;
